/* HF Main Product — the section's behaviour, served as a cached asset
   instead of ~22KB of code inlined into every product page, alongside a
   59KB dump of every variant field (2026-09-14). Everything the template
   used to interpolate now arrives in window.HF_MP_CFG, which the section
   prints just above this file: uid, option indexes, the current selection,
   bundle percentages, ship lead, currency symbol, and a variants array
   trimmed to the six fields this code actually reads.
   Loaded WITHOUT defer, on purpose and in the same position the inline
   script occupied, so it still runs before layout/theme.liquid's own
   inline blocks further down the page — those click this section's option
   buttons and depend on its handlers already being attached. */
(function(){
  var CFG=window.HF_MP_CFG||{};
  var root=document.getElementById('hf-mp-'+CFG.uid); if(!root) return;
  var sticky=document.getElementById('hf-sticky-'+CFG.uid);
  var variants=CFG.variants||[];
  var money=function(c){return (CFG.currency||'$')+(c/100).toFixed(2);};
  var nOpts=CFG.nOpts||0;
  var sel=(CFG.sel||[]).slice();
  var qty=1, view='w';
  var q=function(s){return root.querySelector(s);};
  var esc=function(v){return window.CSS&&CSS.escape?CSS.escape(v):v;};
  var modal=q('[data-mp-modal]');
  var quiz=q('[data-mp-quiz]');
  var bogo=q('[data-bg-wrap]');
  var qstate={brand:'',gender:'w',sizeVal:'',fit:'',width:'',use:'',rec:''};
  var qstep=1;
  var colorIdx=CFG.colorIdx, sizeIdx=CFG.sizeIdx;
  var hfGalFilter=null;
  var lastColor=(CFG.colorIdx>=0)?CFG.lastColor:null;
  var imgMap={};
  variants.forEach(function(v){
    if(colorIdx<0) return;
    var c=v.options[colorIdx];
    if(!imgMap[c] && v.featured_image && v.featured_image.src) imgMap[c]=v.featured_image.src;
  });
  function cdn(src,w){ return src+(src.indexOf('?')>-1?'&':'?')+'width='+w; }
  function openModal(){ if(!modal) return false; modal.hidden=false; document.body.style.overflow='hidden'; return true; }
  function closeModal(){ if(modal){ modal.hidden=true; } if(quiz){ quiz.hidden=true; } document.body.style.overflow=''; }
  if(bogo){
    var bc1=q('[data-bg-c="1"]'), bs1=q('[data-bg-s="1"]'), bc2=q('[data-bg-c="2"]'), bs2=q('[data-bg-s="2"]');
    var batc=q('[data-bg-atc]'), berr=q('[data-bg-err]');
    var bfind=function(color,size){
      for(var i=0;i<variants.length;i++){
        if(variants[i].options[colorIdx]===color && variants[i].options[sizeIdx]===size) return variants[i];
      }
      return null;
    };
    var bpaint=function(){
      var i1=q('[data-bg-img="1"]'), i2=q('[data-bg-img="2"]');
      /* Only repaint a tile whose colour actually changed: the section
         renders both tiles already sized for their colours, and swapping in
         the variant's raw image at load fetched a 2048px file for nothing. */
      var n1=q('[data-bg-cname="1"]'), n2=q('[data-bg-cname="2"]');
      if(imgMap[bc1.value]&&n1.textContent!==bc1.value) i1.src=imgMap[bc1.value];
      if(imgMap[bc2.value]&&n2.textContent!==bc2.value) i2.src=imgMap[bc2.value];
      q('[data-bg-cname="1"]').textContent=bc1.value;
      q('[data-bg-cname="2"]').textContent=bc2.value;
      var ready=!!(bs1.value&&bs2.value);
      var v=ready?bfind(bc1.value,bs1.value):null;
      batc.disabled=!(ready&&v&&v.available);
      berr.classList.remove('is-on');
      if(ready&&v&&!v.available){ berr.textContent='That size is sold out - try another.'; berr.classList.add('is-on'); }
    };
    [bc1,bs1,bc2,bs2].forEach(function(sel2){ sel2.addEventListener('change',bpaint); });
    batc.addEventListener('click',function(){
      if(!(bs1.value&&bs2.value)){ berr.textContent='Please select a size for both pairs.'; berr.classList.add('is-on'); return; }
      var v=bfind(bc1.value,bs1.value);
      if(!v||!v.available){ berr.textContent='That size is sold out - try another.'; berr.classList.add('is-on'); return; }
      batc.disabled=true;
      var props={};
      props['FREE Pair - Color']=bc2.value;
      props['FREE Pair - Size']=bs2.value;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1,properties:props}]})})
        .then(function(r){
          if(!r.ok) throw new Error('add failed');
          /* Slide the cart drawer open instead of navigating to /cart, so the
             shopper stays on the page and sees the drawer's upsells. Falls
             back to the cart page if the drawer section isn't on the page. */
          if(window.HFCartDrawer){ return window.HFCartDrawer.refresh().then(window.HFCartDrawer.open); }
          window.location.href='/cart';
        })
        .catch(function(){ batc.disabled=false; berr.textContent='Could not add to cart - please try again.'; berr.classList.add('is-on'); });
    });
    bpaint();
  }
  /* ---- bundle pair picker ---- */
  var pairs=[];
  var pairsBox=q('[data-mp-pairs]'), pairList=q('[data-mp-pairlist]');
  var hasDual=!!q('[data-mp-tab]');
  function pairsOn(){ return pairs.length>=2; }
  function sizeParts(val){
    if(val.indexOf('Women')>-1&&val.indexOf('Men')>-1){
      var pp=val.split(' - ');
      return {w:pp[0].replace('Women','W').trim(), m:(pp[1]||'').replace('Men','M').trim()};
    }
    return {w:val,m:val};
  }
  function pvariant(pr){
    for(var i=0;i<variants.length;i++){
      var ok=true;
      if(colorIdx>=0&&variants[i].options[colorIdx]!==pr.color) ok=false;
      if(sizeIdx>=0&&variants[i].options[sizeIdx]!==pr.size) ok=false;
      if(ok) return variants[i];
    }
    return null;
  }
  function colorValues(){
    var out=[]; if(colorIdx<0) return out;
    variants.forEach(function(v){ if(out.indexOf(v.options[colorIdx])<0) out.push(v.options[colorIdx]); });
    return out;
  }
  function sizeValues(){
    var out=[]; if(sizeIdx<0) return out;
    variants.forEach(function(v){ if(out.indexOf(v.options[sizeIdx])<0) out.push(v.options[sizeIdx]); });
    return out;
  }
  function renderPairs(){
    if(!pairList) return;
    var cvs=colorValues(), svs=sizeValues();
    pairList.innerHTML='';
    pairs.forEach(function(pr,idx){
      var row=document.createElement('div'); row.className='hf-mp__pr';
      var v=pvariant(pr);
      var stock=v&&v.available;
      var html='';
      html+='<div class="hf-mp__prtop"><span class="hf-mp__prlab">Pair #'+(idx+1)+'</span>';
      html+='<span class="hf-mp__prstock'+(stock?'':' is-out')+'"><i></i>'+(stock?'In Stock':'Sold Out')+'</span></div>';
      html+='<button type="button" class="hf-mp__prx" data-mp-prx="'+idx+'" aria-label="Remove pair">&#10005;</button>';
      html+='<div class="hf-mp__prbody"><div class="hf-mp__prthumb">'+(imgMap[pr.color]?'<img src="'+imgMap[pr.color]+'" alt="">':'')+'</div>';
      html+='<div class="hf-mp__prfields'+(hasDual?' has-g':'')+'">';
      if(hasDual){
        html+='<div class="hf-mp__prf"><label>Gender</label><select data-mp-prg="'+idx+'">';
        html+='<option value="w"'+(pr.gender==='w'?' selected':'')+'>Women</option>';
        html+='<option value="m"'+(pr.gender==='m'?' selected':'')+'>Men</option>';
        html+='</select></div>';
      }
      if(colorIdx>=0){
        html+='<div class="hf-mp__prf"><label>Color</label><select data-mp-prc="'+idx+'">';
        cvs.forEach(function(cv){ html+='<option value="'+cv.replace(/"/g,'&quot;')+'"'+(pr.color===cv?' selected':'')+'>'+cv+'</option>'; });
        html+='</select></div>';
      }
      if(sizeIdx>=0){
        html+='<div class="hf-mp__prf"><label>Size</label><select data-mp-prs="'+idx+'">';
        svs.forEach(function(sv){
          var lab=hasDual?(pr.gender==='m'?sizeParts(sv).m:sizeParts(sv).w):sv;
          html+='<option value="'+sv.replace(/"/g,'&quot;')+'"'+(pr.size===sv?' selected':'')+'>'+lab+'</option>';
        });
        html+='</select></div>';
      }
      html+='</div></div>';
      row.innerHTML=html;
      pairList.appendChild(row);
    });
    if(pairsBox) pairsBox.hidden=!pairsOn();
    root.querySelectorAll('[data-mp-bundle]').forEach(function(x){
      x.classList.toggle('is-on', pairsOn()&&parseInt(x.getAttribute('data-mp-bundle'),10)===pairs.length);
    });
  }
  function enterBundle(n){
    qty=1;
    pairs=[];
    for(var i=0;i<n;i++) pairs.push({color:colorIdx>=0?sel[colorIdx]:'', size:sizeIdx>=0?sel[sizeIdx]:'', gender:view});
    renderPairs(); paint();
  }
  function exitBundle(){ pairs=[]; renderPairs(); paint(); }
  /* ---- standard variant engine ---- */
  function qshow(n){
    qstep=n;
    quiz.querySelectorAll('[data-qz-step]').forEach(function(pn){ pn.classList.toggle('is-on', parseInt(pn.getAttribute('data-qz-step'),10)===n); });
    quiz.querySelectorAll('.hf-mp__qzdot').forEach(function(d,i){ d.classList.toggle('is-on', i+1<=n); });
    var bk=quiz.querySelector('[data-qz-back]'); if(bk) bk.style.visibility=n>1?'visible':'hidden';
    if(n===3) qsizes();
    if(n===7) qresult();
  }
  function qsizes(){
    var wrap=quiz.querySelector('[data-qz-sizes]'); if(!wrap) return; wrap.innerHTML='';
    var bn=quiz.querySelector('[data-qz-brandname]'); if(bn) bn.textContent=qstate.brand||'your usual brand';
    root.querySelectorAll('.hf-mp__szb').forEach(function(sb){
      var lab=(qstate.gender==='m'?sb.getAttribute('data-ml'):sb.getAttribute('data-wl'))||sb.getAttribute('data-mp-val');
      var b=document.createElement('button'); b.type='button'; b.className='hf-mp__qzsz'; b.textContent=lab;
      b.setAttribute('data-qz-size', sb.getAttribute('data-mp-val'));
      wrap.appendChild(b);
    });
  }
  function qresult(){
    var sbs=[].slice.call(root.querySelectorAll('.hf-mp__szb'));
    var vals=sbs.map(function(sb){return sb.getAttribute('data-mp-val');});
    var i=vals.indexOf(qstate.sizeVal); if(i<0) i=0;
    var d=0;
    if(qstate.fit==='tight') d+=1;
    if(qstate.fit==='loose') d-=1;
    if(qstate.width==='wide') d+=1;
    if(d>1) d=1; if(d<-1) d=-1;
    var ri=Math.max(0,Math.min(vals.length-1,i+d));
    qstate.rec=vals[ri];
    var sb=sbs[ri];
    var lab=(qstate.gender==='m'?sb.getAttribute('data-ml'):sb.getAttribute('data-wl'))||qstate.rec;
    var r1=quiz.querySelector('[data-qz-result]'); if(r1) r1.textContent=lab;
    var r2=quiz.querySelector('[data-qz-resfull]'); if(r2) r2.textContent=qstate.rec;
  }
  function sizeLabel(val){
    var b=root.querySelector('[data-mp-opt="'+CFG.sizeIdx+'"][data-mp-val="'+esc(val)+'"]');
    if(!b) return val;
    return (view==='m'?b.getAttribute('data-ml'):b.getAttribute('data-wl'))||val;
  }
  function find(){
    for (var i=0;i<variants.length;i++){
      var ok=true;
      for (var j=0;j<nOpts;j++){ if(variants[i].options[j]!==sel[j]){ok=false;break;} }
      if(ok) return variants[i];
    }
    return null;
  }
  function paint(){
    var v=find();
    var atc=q('[data-mp-atc]'), lbl=q('[data-mp-atclabel]');
    if(!atc) return;
    /* No variant yet (e.g. the size is still unpicked, which theme.liquid
       now forces on load) must not freeze the swatches: highlight the
       clicked colour, update the summary and swap the gallery anyway, so a
       colour click shows that colour's photos before a size is chosen. */
    if(!v){
      atc.disabled=true; lbl.textContent='Unavailable';
      root.querySelectorAll('[data-mp-opt]').forEach(function(b){
        var i=parseInt(b.getAttribute('data-mp-opt'),10);
        b.classList.toggle('is-on', sel[i]===b.getAttribute('data-mp-val'));
      });
      var sum0='';
      if(CFG.colorIdx>=0) sum0+='Color: <b>'+sel[CFG.colorIdx]+'</b>&nbsp;&nbsp;';
      if(CFG.sizeIdx>=0) sum0+='Size: <b>'+(sel[CFG.sizeIdx]?sizeLabel(sel[CFG.sizeIdx]):'Select size')+'</b>';
      var sume0=q('[data-mp-sum]'); if(sume0) sume0.innerHTML=sum0;
      if(colorIdx>=0 && sel[colorIdx]!==lastColor){
        lastColor=sel[colorIdx];
        if(typeof hfGalFilter==='function') hfGalFilter();
      }
      return;
    }
    q('[data-mp-id]').value=v.id;
    q('[data-mp-qty]').value=qty;
    var pr=v.price, cp=v.compare_at_price||0;
    q('[data-mp-price]').textContent=money(pr);
    var was=q('[data-mp-was]'); was.hidden=!(cp>pr); if(cp>pr) was.textContent=money(cp);
    var sv=q('[data-mp-save]'), svt=q('[data-mp-save-txt]');
    sv.hidden=!(cp>pr); if(cp>pr&&svt) svt.textContent='Save '+Math.round((cp-pr)*100/cp)+'%';
    var pillEl=q('[data-mp-pill]'), pw=q('[data-mp-pillwas]');
    if(pairsOn()){
      var tot=0, totWas=0, allOk=true;
      pairs.forEach(function(pr2){
        var pv=pvariant(pr2);
        if(!pv||!pv.available){ allOk=false; return; }
        tot+=pv.price; totWas+=(pv.compare_at_price||pv.price);
      });
      if(allOk){
        pillEl.textContent=money(tot);
        pw.hidden=!(totWas>tot); if(totWas>tot) pw.textContent=money(totWas);
        atc.disabled=false; lbl.textContent='Add to Cart';
      } else {
        atc.disabled=true; lbl.textContent='Pick In-Stock Pairs';
      }
    } else {
      pillEl.textContent=money(pr*qty);
      pw.hidden=!(cp>pr); if(cp>pr) pw.textContent=money(cp*qty);
      atc.disabled=!v.available; lbl.textContent=v.available?'Add to Cart':'Sold Out';
    }
    var sum='';
    if(CFG.colorIdx>=0) sum+='Color: <b>'+sel[CFG.colorIdx]+'</b>&nbsp;&nbsp;';
    if(CFG.sizeIdx>=0) sum+='Size: <b>'+sizeLabel(sel[CFG.sizeIdx])+'</b>';
    var sume=q('[data-mp-sum]'); if(sume) sume.innerHTML=sum;
    var p2=CFG.bundle2Pct, p3=CFG.bundle3Pct;
    var b2=q('[data-mp-b2]');
    if(b2){
      var base=cp>pr?cp:pr;
      var pp2=Math.round(pr*(100-p2)/100), pp3=Math.round(pr*(100-p3)/100);
      b2.textContent=money(pp2); q('[data-mp-b2was]').textContent=money(base);
      q('[data-mp-b2sv]').textContent=Math.round((base-pp2)*100/base)+'%';
      q('[data-mp-b3]').textContent=money(pp3); q('[data-mp-b3was]').textContent=money(base);
      q('[data-mp-b3sv]').textContent=Math.round((base-pp3)*100/base)+'%';
    }
    if(sticky){
      sticky.querySelector('[data-mp-stprice]').textContent=money(pr);
      var ss=sticky.querySelector('[data-mp-stsave]'); ss.hidden=!(cp>pr); if(cp>pr) ss.textContent='Save '+Math.round((cp-pr)*100/cp)+'%';
      sticky.querySelectorAll('select[data-mp-stopt]').forEach(function(s){ s.value=sel[parseInt(s.getAttribute('data-mp-stopt'),10)]; });
    }
    root.querySelectorAll('[data-mp-opt]').forEach(function(b){
      var i=parseInt(b.getAttribute('data-mp-opt'),10);
      b.classList.toggle('is-on', sel[i]===b.getAttribute('data-mp-val'));
    });
    if(!pairsOn()){
      root.querySelectorAll('[data-mp-bundle]').forEach(function(x){ x.classList.remove('is-on'); });
    }
    if(colorIdx>=0 && sel[colorIdx]!==lastColor){
      lastColor=sel[colorIdx];
      if(typeof hfGalFilter==='function') hfGalFilter();
    }
    /* The sticky bar's thumbnail shows the colour the shopper picked
       (client 2026-09-14); it used to stay on the featured black shoe.
       The variant's own image wins, the gallery's main photo is the
       fallback for a colour whose variants carry no image. */
    if(sticky && colorIdx>=0){
      var stImg=sticky.querySelector('img'), stSrc=imgMap[sel[colorIdx]];
      if(!stSrc){ var gh=root.querySelector('[data-mp-gal] img.is-hero'); stSrc=gh&&gh.getAttribute('src'); }
      if(stImg && stSrc){
        var want=stSrc.indexOf('width=')>-1?stSrc:cdn(stSrc,120);
        if(stImg.getAttribute('src')!==want){ stImg.removeAttribute('srcset'); stImg.removeAttribute('sizes'); stImg.setAttribute('src',want); }
      }
    }
  }
  var mainForm=document.getElementById('hf-mp-form');
  if(mainForm){
    mainForm.addEventListener('submit',function(e){
      if(!pairsOn()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var items=[];
      var allOk=true;
      pairs.forEach(function(pr){
        var pv=pvariant(pr);
        if(!pv||!pv.available){ allOk=false; return; }
        items.push({id:pv.id, quantity:1});
      });
      if(!allOk||!items.length) return;
      var atc=q('[data-mp-atc]'); if(atc) atc.disabled=true;
      /* The drawer opens at once and fills in from the same response
         (HFCartDrawer.add, 2026-09-15); the cart page is the fallback if the
         drawer section is missing. */
      if(window.HFCartDrawer&&window.HFCartDrawer.add){
        window.HFCartDrawer.add({items:items}).catch(function(){}).then(function(){ if(atc){ atc.disabled=false; } });
        return;
      }
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){ if(!r.ok) throw new Error('add failed'); window.location.href='/cart'; })
        .catch(function(){ if(atc){ atc.disabled=false; } });
    }, true);
  }
  root.addEventListener('change',function(e){
    var g=e.target.closest('[data-mp-prg]');
    if(g){ pairs[parseInt(g.getAttribute('data-mp-prg'),10)].gender=g.value; renderPairs(); paint(); return; }
    var c=e.target.closest('[data-mp-prc]');
    if(c){ pairs[parseInt(c.getAttribute('data-mp-prc'),10)].color=c.value; renderPairs(); paint(); return; }
    var s2=e.target.closest('[data-mp-prs]');
    if(s2){ pairs[parseInt(s2.getAttribute('data-mp-prs'),10)].size=s2.value; renderPairs(); paint(); return; }
  });
  root.addEventListener('click',function(e){
    if(e.target.closest('[data-mp-modal-close]')||e.target.closest('[data-mp-quiz-close]')){ closeModal(); return; }
    var qo=e.target.closest('[data-mp-quiz-open]');
    if(qo){
      if(quiz){ e.preventDefault(); quiz.hidden=false; document.body.style.overflow='hidden'; qstate={brand:'',gender:'w',sizeVal:'',fit:'',width:'',use:'',rec:''}; qshow(1); }
      else if(openModal()){ e.preventDefault(); }
      return;
    }
    var sc=e.target.closest('[data-mp-sizechart]');
    if(sc){ if(openModal()) e.preventDefault(); return; }
    if(quiz && !quiz.hidden){
      var back=e.target.closest('[data-qz-back]'); if(back){ if(qstep>1) qshow(qstep-1); return; }
      var sz=e.target.closest('[data-qz-size]'); if(sz){ qstate.sizeVal=sz.getAttribute('data-qz-size'); qshow(4); return; }
      var ap=e.target.closest('[data-qz-apply]');
      if(ap){
        var tab=root.querySelector('[data-mp-tab="'+qstate.gender+'"]'); if(tab) tab.click();
        var sb=root.querySelector('.hf-mp__szb[data-mp-val="'+esc(qstate.rec)+'"]'); if(sb) sb.click();
        closeModal();
        return;
      }
      var opt=e.target.closest('[data-qz-opt]');
      if(opt){
        var k=opt.getAttribute('data-qz-opt'), v2=opt.getAttribute('data-qz-val');
        qstate[k]=v2;
        if(k==='brand') qshow(2);
        else if(k==='gender') qshow(3);
        else if(k==='fit') qshow(5);
        else if(k==='width') qshow(6);
        else if(k==='use') qshow(7);
        return;
      }
    }
    var rl=e.target.closest('[data-mp-revlink]');
    if(rl){
      var lx=document.getElementById('looxReviews')||document.querySelector('[id*="loox" i],[class*="loox" i]');
      if(lx){ e.preventDefault(); lx.scrollIntoView({behavior:'smooth',block:'start'}); }
      return;
    }
    var tab2=e.target.closest('[data-mp-tab]');
    if(tab2){
      view=tab2.getAttribute('data-mp-tab');
      root.querySelectorAll('[data-mp-tab]').forEach(function(t){t.classList.toggle('is-on',t===tab2);});
      root.querySelectorAll('[data-mp-opt="'+CFG.sizeIdx+'"]').forEach(function(sb){
        var lab=sb.querySelector('[data-mp-szlab]');
        if(lab){ lab.textContent=(view==='m'?sb.getAttribute('data-ml'):sb.getAttribute('data-wl'))||lab.textContent; }
      });
      paint(); return;
    }
    var b=e.target.closest('[data-mp-opt]');
    if(b){ sel[parseInt(b.getAttribute('data-mp-opt'),10)]=b.getAttribute('data-mp-val'); paint(); return; }
    var px=e.target.closest('[data-mp-prx]');
    if(px){
      pairs.splice(parseInt(px.getAttribute('data-mp-prx'),10),1);
      if(pairs.length<2){ exitBundle(); } else { renderPairs(); paint(); }
      return;
    }
    var ad=e.target.closest('[data-mp-addpair]');
    if(ad){
      if(pairs.length<6){
        var last=pairs[pairs.length-1]||{color:colorIdx>=0?sel[colorIdx]:'', size:sizeIdx>=0?sel[sizeIdx]:'', gender:view};
        pairs.push({color:last.color,size:last.size,gender:last.gender});
        renderPairs(); paint();
      }
      return;
    }
    var bd=e.target.closest('[data-mp-bundle]');
    if(bd){
      var n=parseInt(bd.getAttribute('data-mp-bundle'),10);
      if(bd.classList.contains('is-on')&&pairs.length===n){ exitBundle(); }
      else { enterBundle(n); }
    }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeModal(); });
  if(sticky){
    sticky.addEventListener('change',function(e){
      var s=e.target.closest('select[data-mp-stopt]'); if(!s) return;
      sel[parseInt(s.getAttribute('data-mp-stopt'),10)]=s.value; paint();
    });
    var onScroll=function(){ sticky.classList.toggle('is-on', window.scrollY>560); sticky.setAttribute('aria-hidden', window.scrollY>560?'false':'true'); };
    window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
  }
  var mintro=q('[data-mp-mintro]'), ianchor=q('[data-mp-anchor]');
  if(mintro&&ianchor){
    var mq=window.matchMedia('(max-width:991px)');
    var placeIntro=function(){
      [q('.hf-mp__quote'),q('.hf-mp__purch'),q('.hf-mp__head'),q('.hf-mp__stars')].forEach(function(el){
        if(!el) return;
        if(mq.matches){ mintro.appendChild(el); } else { ianchor.parentNode.insertBefore(el,ianchor); }
      });
    };
    placeIntro();
    if(mq.addEventListener) mq.addEventListener('change',placeIntro);
  }
  var gal=q('[data-mp-gal]'), gdots=q('[data-mp-gdots]');
  if(gal&&gdots){
    var gimgs=gal.querySelectorAll('img');
    var gthumbs=root.querySelectorAll('[data-mp-gthumb]');
    /* shown[] maps carousel position -> original media index, so the dots and
       thumbs stay in step once some slides are filtered out by colour. */
    var shown=[];
    for(var gi=0;gi<gimgs.length;gi++){
      var d=document.createElement('button'); d.type='button'; d.className='hf-mp__gdot'+(gi===0?' is-on':'');
      d.setAttribute('data-mp-gdot',gi); d.setAttribute('aria-label','Image '+(gi+1));
      gdots.appendChild(d);
      shown.push(gi);
    }
    var gdotEls=gdots.querySelectorAll('.hf-mp__gdot');
    var setSlide=function(i){
      gdotEls.forEach(function(x,j){x.classList.toggle('is-on',j===i);});
      gthumbs.forEach(function(x,j){x.classList.toggle('is-on',j===i);});
    };
    /* Which colourway is on screen: pair 1 drives it in BOGO mode, otherwise
       the selected colour swatch. Images with no data-c (the info cards) always show. */
    var activeColor=function(){
      var bg=root.querySelector('[data-bg-c="1"]');
      if(bg&&bg.value) return bg.value.toLowerCase();
      var on=root.querySelector('[data-mp-opt="'+colorIdx+'"].is-on');
      if(on) return (on.getAttribute('data-mp-val')||'').toLowerCase();
      return '';
    };
    /* Placeholder photos (client 2026-09-14): Grey and Black & White only
       have two studio shots of their own, so until more are uploaded a
       colour with fewer than GAL_TARGET photos is topped up with Black and
       Beige lifestyle shots (never their studio profiles, which would read
       as the wrong shoe). The pick is FIXED, not random, and the section's
       Liquid computes the same set for the colour the page opens on, so
       those photos are already on screen at first paint (a random pick made
       after paint shifted the desktop grid). Keep this rule identical to the
       one in hf-main-product.liquid: own + untagged photos count; fill from
       Black then Beige in turns; each pool is that colour's non-studio
       photos after the target colour's first own photo, in gallery order. */
    var GAL_TARGET=7, FILL_FROM=['black','beige'], fillPick={};
    var fillersFor=function(c){
      if(!c||FILL_FROM.indexOf(c)>-1) return {};
      if(fillPick[c]) return fillPick[c];
      var own=0, first=-1;
      gimgs.forEach(function(img,i){
        var mc=(img.getAttribute('data-c')||'').toLowerCase();
        if(!mc||mc===c){ own++; if(mc===c&&first<0) first=i; }
      });
      var need=GAL_TARGET-own, pick={};
      if(need>0&&first>-1){
        var pools=FILL_FROM.map(function(fc){
          var pool=[];
          gimgs.forEach(function(img,i){
            if(i>first&&(img.getAttribute('data-c')||'').toLowerCase()===fc&&!img.hasAttribute('data-studio')) pool.push(i);
          });
          return pool;
        });
        for(var r=0;need>0&&r<gimgs.length;r++){
          for(var k=0;k<pools.length&&need>0;k++){
            if(pools[k][r]!==undefined){ pick[pools[k][r]]=true; need--; }
          }
        }
      }
      fillPick[c]=pick;
      return pick;
    };
    hfGalFilter=function(){
      var c=activeColor(); shown=[];
      var fill=fillersFor(c);
      gimgs.forEach(function(img,i){
        var mc=(img.getAttribute('data-c')||'').toLowerCase();
        var vis=(!mc||!c||mc===c||!!fill[i]);
        img.style.display=vis?'':'none';
        if(gthumbs[i]) gthumbs[i].style.display=vis?'':'none';
        if(gdotEls[i]) gdotEls[i].style.display=vis?'':'none';
        if(vis) shown.push(i);
      });
      gimgs.forEach(function(img){ img.classList.remove('is-hero'); });
      if(shown.length) gimgs[shown[0]].classList.add('is-hero');
      gal.scrollLeft=0;
      setSlide(shown.length?shown[0]:0);
    };
    var gtick=false;
    gal.addEventListener('scroll',function(){
      if(gtick) return; gtick=true;
      requestAnimationFrame(function(){
        gtick=false;
        var w=gal.clientWidth; if(w<1) return;
        var list=shown.length?shown:null;
        var n=list?list.length:gimgs.length;
        var i=Math.max(0,Math.min(n-1,Math.round(gal.scrollLeft/(w+10))));
        setSlide(list?list[i]:i);
      });
    },{passive:true});
    root.addEventListener('click',function(e){
      var t=e.target.closest('[data-mp-gdot],[data-mp-gthumb]');
      if(!t) return;
      var i=parseInt(t.getAttribute('data-mp-gdot')||t.getAttribute('data-mp-gthumb'),10);
      var pos=shown.indexOf(i); if(pos<0) pos=0;
      gal.scrollTo({left:pos*(gal.clientWidth+10),behavior:'smooth'});
      setSlide(i);
    });
    root.addEventListener('click',function(e){ if(e.target.closest('[data-mp-opt]')) setTimeout(hfGalFilter,0); });
    root.addEventListener('change',function(e){ if(e.target.closest('[data-bg-c]')) setTimeout(hfGalFilter,0); });
    hfGalFilter();
  }
  var sb=root.querySelector('[data-mp-shipby]');
  if(sb){
    var d=new Date(); var add=CFG.shipLead;
    while(add>0){ d.setDate(d.getDate()+1); if(d.getDay()!==0&&d.getDay()!==6) add--; }
    var DAYS=['SUN','MON','TUE','WED','THU','FRI','SAT'],MONS=['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
    sb.textContent=DAYS[d.getDay()]+', '+MONS[d.getMonth()]+' '+d.getDate();
  }
  if(!bogo) paint();
})();
